<button #btn type="button" pButton icon="pi pi-bars" (click)="menu.toggle($event)"></button>
<p-slideMenu  #menu  [model]="items" [popup]="true" [viewportHeight]="350" [backLabel]="'Retour'" [menuWidth]="250"></p-slideMenu>
